import { getData } from 'src/services/RestApi';
import { getCachedData } from 'src/utils/data-cache';
import { formatPhone, formatCode } from 'src/utils/formatters';
import { GenderDisplay } from 'src/constants/keys-mapping';

export const getAccounts = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/account/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  if (result) {
    const keysMapping = getCachedData('keysMapping');
    const partner = keysMapping?.partner || {};

    const statusColorMap = {
      0: 'warning.main',
      3: 'error.main',
    };
    result.forEach((element) => {
      // element.gender = gender[element.gender];
      element.partnerType = partner[element.partnerType];
      element.code = formatCode(element.code);
      element.phone = formatPhone(element.phone);
      element.statusColor = statusColorMap[element.status] || 'inherit';
   
      if(element.key === 'hv'){
        element.gender = element.degreeName;
        element.options = element.partnerName;
      }else{
        element.gender = GenderDisplay[element.gender];
        if(element.key === 'nv')
          element.options = element.email;
        else if(element.key === 'gv')
          element.options = element.degreeName;
      }
    });
  }
  return onSuccess(result);
};

export const getAccountById = async (payload) => {
  const accountId = Number(payload?.id) || 0;
  if (accountId === 0) return {};

  const endPoint = 'api/account/detail';
  let { result, error } = await getData(endPoint, { accountId });

  if(error) return {};

  if(result){
    const keysMapping = getCachedData('keysMapping');
    const partner = keysMapping?.partner || {};

    result.partnerType = partner[result.partnerType];
    
    getStatusMapper(result);
  }
  return result;
};

export const getStatusMapper = (result) => {
  if(result.status === 0){
    result.statusName = 'Đã bị khóa';
    result.statusVerify = 'Vô hiệu tài khoản';
  }else if(result.status === 3){
    result.statusName = 'Ngưng hoạt động';
    result.statusVerify = 'Xóa tài khoản';
  }else{
    result.statusName = 'Hoạt động';
    result.statusVerify = 'Khóa tài khoản';
  }
  return result;
};
